/**
 * @fileoverview `usePopularSearches` (FRE-824) — curated static popular
 * searches surfaced on the empty-state SearchSheet view.
 *
 * Static v1 implementation. A backend-driven variant is intentionally out
 * of scope for FRE-824 — when that lands, swap this hook's body for a
 * RTK Query call without changing the consumer-facing shape.
 *
 * The list is intentionally short (6 items) and ordered for visual
 * hierarchy: time-bound queries first (`tonight`, `this weekend`), then
 * price/format filters (`free`), then category-ish queries (`live music`,
 * `rooftop`, `food trucks`). All items are LOWERCASE, free-text queries
 * that flow through the same `q=` param as recent searches — no special
 * routing.
 */

/* ------------------------------------------------------------------ */
/*  Static catalogue — single source of truth                          */
/* ------------------------------------------------------------------ */

const POPULAR_SEARCHES = [
  'tonight',
  'this weekend',
  'free',
  'live music',
  'rooftop',
  'food trucks',
] as const;

/** Tuple type for the curated popular-search catalogue. */
export type PopularSearch = (typeof POPULAR_SEARCHES)[number];

/* ------------------------------------------------------------------ */
/*  Hook                                                               */
/* ------------------------------------------------------------------ */

/**
 * Returns the curated popular-search catalogue. Stable identity — the
 * underlying tuple is module-level, so referential-equality consumers
 * (e.g. `useMemo` dependency arrays) never see a fresh array.
 */
export function usePopularSearches(): readonly PopularSearch[] {
  return POPULAR_SEARCHES;
}
